// extracted by mini-css-extract-plugin
export default {"table":"table_table__yJovZ","table__content":"table_table__content__iE6Rd"};